
webpack.register(
    'components/modal-backdrop/modal-backdrop',
    function() {
        return require('components/modal-backdrop/modal-backdrop');
    },
    false
);
webpack.register(
    'components/svg-image/svg-image',
    function() {
        return require('components/svg-image/svg-image');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from='components/modal-backdrop/modal-backdrop'/>\r\n<can-import from='components/svg-image/svg-image'/>\r\n\r\n{{#if isShown}}\r\n    <div class=\"c-modal-dialog-new-content js-modal-dialog\">\r\n        <div class=\"c-modal-dialog-new-content__wrapper\">\r\n            <content />\r\n            <div class=\"js-modal-dialog__close c-modal-dialog-new-content__close\">\r\n                <svg-image class-name=\"c-modal-dialog-new-content__icon\" image=\"sprites.svg#icon-close\"></svg-image>\r\n            </div>\r\n        </div>\r\n        <modal-backdrop {is-visible}='isShown' (clicked)=\"modalClosed()\"></modal-backdrop>\r\n    </div>\r\n{{/if}}\r\n");